module.exports = __webpack_public_path__ + "media/images/athletes/126-88279ec6fdbe3a554522e90d96b06e36.png";